import { GemType, GenericGraphProcessType, CommonGraph } from '@common/types';

export function getGemTypeByProcess<G extends CommonGraph>(process: GenericGraphProcessType<G>): GemType {
  return { component: process.component, componentInfo: process.componentInfo };
}
